import { Eye, EyeOff, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { BLOCKS } from "@/lib/invoiceLayout";

const Num = ({ label, value, onChange, min, max, step = 1, testid }) => (
  <div className="space-y-1"><Label className="text-xs">{label}</Label>
    <Input type="number" className="h-8" value={Math.round(value * 100) / 100} min={min} max={max} step={step} data-testid={testid}
      onChange={(e) => onChange(Math.min(max, Math.max(min, parseFloat(e.target.value) || 0)))} /></div>
);

export default function LayoutItemPanel({ it, patch, remove }) {
  const info = BLOCKS[it.key];
  return (
    <div className="border rounded-md p-3 space-y-3" data-testid="layout-item-panel">
      <div className="flex items-center justify-between">
        <p className="text-sm font-medium">{info.name}</p>
        <Button size="sm" variant="ghost" onClick={() => patch({ hidden: !it.hidden })} data-testid="layout-item-hide">
          {it.hidden ? <><EyeOff size={14} /> Hidden</> : <><Eye size={14} /> Shown</>}
        </Button>
      </div>
      <div className="grid grid-cols-3 gap-2">
        <Num label="Left (px)" value={it.x} min={-200} max={1200} onChange={(x) => patch({ x })} testid="layout-x" />
        <Num label="Top (px)" value={it.y} min={-200} max={1400} onChange={(y) => patch({ y })} testid="layout-y" />
        <Num label="Width (px)" value={it.w} min={10} max={900} onChange={(w) => patch({ w })} testid="layout-w" />
      </div>
      {it.key !== "line" && it.key !== "logo" && (
        <div className="flex items-end gap-3">
          <div className="w-24"><Num label="Text size" value={it.size} min={5} max={80} step={0.5} onChange={(size) => patch({ size })} testid="layout-size" /></div>
          <label className="flex items-center gap-2 text-sm h-8"><Checkbox checked={it.bold} onCheckedChange={(v) => patch({ bold: !!v })} data-testid="layout-bold" /> Bold</label>
        </div>
      )}
      {(it.key === "logo" || it.key === "line") && <Num label={it.key === "logo" ? "Height (px)" : "Thickness (px)"} value={it.h} min={1} max={it.key === "logo" ? 600 : 10} onChange={(h) => patch({ h })} testid="layout-h" />}
      {info.lines && <Num label="Ruled lines" value={it.lines} min={0} max={40} onChange={(lines) => patch({ lines: Math.round(lines) })} testid="layout-lines" />}
      {it.key === "text" && <div className="space-y-1"><Label className="text-xs">Text</Label>
        <Textarea rows={3} value={it.text} maxLength={2000} onChange={(e) => patch({ text: e.target.value })} data-testid="layout-text" /></div>}
      {Object.keys(info.labels).length > 0 && (
        <div className="space-y-2">
          <p className="text-xs text-muted-foreground">Labels</p>
          {Object.entries(info.labels).map(([k, def]) => (
            <Input key={k} className="h-8" maxLength={80} placeholder={def} value={it.labels?.[k] ?? def} data-testid={`layout-label-${k}`}
              onChange={(e) => patch({ labels: { ...it.labels, [k]: e.target.value } })} />
          ))}
        </div>
      )}
      {info.custom && <Button size="sm" variant="outline" className="w-full text-destructive border-destructive/40" onClick={remove} data-testid="layout-item-remove"><Trash2 size={14} /> Remove</Button>}
    </div>
  );
}
